module.exports = __webpack_public_path__ + "static/media/Easypm_Couleur-1.8d148378.m4v";